<template>
  <z-dialogo
    ref="dialogo"
    titulo="Composição Estoque"
    scrollable
    dividers
    no-padding
    largura="800px"
    altura="383px"
  >

    <template v-slot:prepend>
      <v-card-title>
        <div>
          {{ produto.referencia }} {{ produto.lote_id ? `(${produto.lote_id})` : '' }} - {{ produto.descricao }}
        </div>
        <v-spacer></v-spacer>
        <div>
          Estoque: {{ produto.estoque }}
        </div>
      </v-card-title>
    </template>

    <template v-slot:texto>
      <v-data-table
        mobile-breakpoint="0"
        disable-pagination
        disable-sort
        hide-default-footer
        :headers="headers"
        :items="entradas"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="(item, index) in items" :key="index" @click="selecionar(item)" :class="{'apontador': item.grade.length > 0}">
              <td>{{ item.id }}</td>
              <td>{{ item.data | dataBR }}</td>
              <td>
                <div>{{ item.fornecedor }}</div>
                <template v-if="item.grade">
                  <v-chip
                    v-for="(_grade, index) in item.grade"
                    class="mr-2"
                    x-small 
                    color="grey lighten-2"
                    :key="index"
                  >{{_grade.descricao}}</v-chip>
                </template>
              </td>
              <td class="text-right">{{ item.balanco | valorBR(0) }}</td>
            </tr>
          </tbody>
        </template>

        <template v-slot:body.append="{ header }">
          <tr>
            <td colspan="4" class="text-right">{{ produto.estoque | valorBR(0) }}</td>
          </tr>
        </template>

      </v-data-table>
    </template>

    <template v-slot:actions_right>
      <v-btn depressed color="primary" @click="fechar()">Fechar</v-btn>
    </template>
  </z-dialogo>
</template>

<script>
import produtosApi from "@/app/services/produtos";

export default {
  name: "DialogoExibirEntradas",

  data() {
    return {
      produtos: [],
      entradas: [],
      headers: [
        { text: "Entrada/Lote", value: "id", width: '120px' },
        { text: "Data", value: "data", width: '100px' },
        { text: "Fornecedor/Grade", value: "fornecedor" },
        { text: "Disponível", value: "saldo", align: "right" },
      ],
      carregando: false,
    };
  },

  computed: {
    produto() {
      return this.$store.state.produtos.produto; 
    }
  },

  methods: {
    async abrir() {
      await this.getEntradas();
      this.$refs.dialogo.abrir();
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },


    async getEntradas() {
      const response = await produtosApi.entradasProduto(this.produto.produto_id);
      this.entradas = response.entradas;
    },

    selecionar(item) {
      this.$emit("selecionar:grade", item);
      this.fechar();
    },

  },
};
</script>

<style scoped></style>
